// Palette
import palette from '../palette';

export default {
  outlined: {},
  contained: {
    backgroundColor: palette.common.primary,
    '&:hover': {
      backgroundColor: palette.common.neutral
    }
  }
};